import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import styled from "styled-components"
import ExternalLinks from "../../../../src/external-links"
import Breakpoints from "../../../components/shared/breakpoints"
import Link from "../../../components/shared/link"
import { T } from "../../styles/typography"
import BreakpointImage from "../../atoms/breakpoint-image"
import { Grid } from "../../atoms/layout-primitives"

const Container = styled.div`
  background: var(--slate);
`

const ContentBlockText = styled.p`
  ${T.sm.body`500`}
  color: var(--body-text-grey);

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body`500`}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body`500`}
  }
`

const LeftImageContainer = styled.div`
  grid-column: 1 / -1;
  justify-self: center;
  width: 100%;
  display: flex;
  flex-direction: column;

  & > * {
    height: 100%;
  }

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 1 / -1;
    justify-self: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / 7;
    max-width: 708px;

    justify-self: end;
  }
`

const PromoContainer = styled.div`
  grid-column: 1 / -1;

  padding: 32px 0;
  align-self: center;

  ${ContentBlockText} {
    margin-top: 24px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
    margin-top: 0;
    justify-self: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: -6 / -1;
    padding: 96px 0;
    align-items: start;
  }
`

const PromoTitle = styled.h3`
  color: var(--white);
  ${T.sm.h3`400`}
  text-align: center;

  font-size: 20px;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h4`400`}
    font-size: 24px;
    justify-self: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h4`400`}
    text-align: left;
    font-size: 30px;
  }
`

const BlogLink = styled(Link)`
  max-width: 316px;
  margin-top: 32px;

  ${(props) => props.styleModifier}

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 48px;
  }
`

export default function MappingSolutionsSection() {
  const query = useStaticQuery(graphql`
    query {
      blogDesktop: file(
        relativePath: {
          eq: "1_SOLUTIONS/Imdf/1_Desktop/blog_image_desktop.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      blogTablet: file(
        relativePath: { eq: "1_SOLUTIONS/Imdf/2_Tablet/blog_image_tablet.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      blogMobile: file(
        relativePath: { eq: "1_SOLUTIONS/Imdf/3_Mobile/blog_image_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <Container>
        <Grid noPadding>
          <LeftImageContainer>
            <BreakpointImage
              imgStyle={{ objectFit: "cover" }}
              imageVariants={{
                sm: query.blogMobile.childImageSharp.fluid,
                md: query.blogTablet.childImageSharp.fluid,
                lg: query.blogDesktop.childImageSharp.fluid,
              }}
            />
          </LeftImageContainer>
          <PromoContainer>
            <PromoTitle>
              Check out our Product 101: IMDF Export Blog to learn more
            </PromoTitle>
            <BlogLink
              target="_blank"
              href={ExternalLinks.hubspot.productImdfExport}
            >
              Read the Blog
            </BlogLink>
          </PromoContainer>
        </Grid>
      </Container>
    </>
  )
}
